var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangePasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 29,
    viewBox: "0 0 23 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.75V7.625C6 4.58625 8.46125 2.125 11.5 2.125C14.5388 2.125 17 4.58625 17 7.625V11.75M11.5 18.625C11.8647 18.625 12.2144 18.4801 12.4723 18.2223C12.7301 17.9644 12.875 17.6147 12.875 17.25C12.875 16.8853 12.7301 16.5356 12.4723 16.2777C12.2144 16.0199 11.8647 15.875 11.5 15.875C11.1353 15.875 10.7856 16.0199 10.5277 16.2777C10.2699 16.5356 10.125 16.8853 10.125 17.25C10.125 17.6147 10.2699 17.9644 10.5277 18.2223C10.7856 18.4801 11.1353 18.625 11.5 18.625ZM11.5 18.625V22.75M4.075 11.75H18.925C20.135 11.75 21.125 12.74 21.125 13.95V23.575C21.125 25.39 19.64 26.875 17.825 26.875H5.175C3.36 26.875 1.875 25.39 1.875 23.575V13.95C1.875 12.74 2.865 11.75 4.075 11.75Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePasswordIcon);
export default __webpack_public_path__ + "static/media/change-password-icon.01257bd84035da53bb96e7ce7c230d9d.svg";
export { ForwardRef as ReactComponent };